export default "__VITE_ASSET__DOlL3lAf__"